import React, { Fragment, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { useMutation } from "@apollo/client";
import {
  Typography,
  ListItem,
  ListItemText,
  Box,
  IconButton,
  Button,
  Popover,
  Tooltip,
} from "@material-ui/core";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import DocThumbnail from "../../../assets/images/file-type/document.svg";
import PdfThumbnail from "../../../assets/images/file-type/pdf.svg";
import XlsThumbnail from "../../../assets/images/file-type/excel.svg";
import VideoThumbnail from "../../../assets/images/file-type/video.svg";
import { addStrengthToText, onEnterSubmit } from "../../../utils/textMentions";
import { flatten, get, isEmpty } from "lodash";
import { updateNotificationMutation } from "../../../graphQL/queries/notifications";
import { useStyles } from "./styles";
import {
  PublishOutlined,
  Favorite,
  FavoriteBorderOutlined,
  ThumbUp,
  ThumbUpAltOutlined,
} from "@material-ui/icons";
import SendIcon from "Assets/images/message-icons/send.svg";
import ReplyIcon from "Assets/images/message-icons/reply.svg";
import GifIcon from "Assets/images/message-icons/gif.svg";
import { useTranslation } from "react-i18next";
import UploadButton from "../../formControls/UploadButton";
import GifSearchBox from "../../formControls/GifSearchBox";
import {
  addGifAttachment,
  addMessageAttachment,
  replyToGrandParentMessage,
  replyToParentMessage,
  saveLikesForGrandParentMessage,
  saveLikesForParentMessage,
} from "../../../graphQL/mutation/communicationMutation";
import axios from "axios";
import TextAreaMention from "../../formControls/TextAreaMention";
import { metaDataDetails } from "../../../recoil/LoggedInUserDetail/selector";
import { useRecoilValue } from "recoil";
import EmojiPicker from "../../formControls/Popovers/EmojiPicker";
import UserProfileWidget from "../../widgets/UserProfileWidget";
import {
  checkStringLength,
  defaultAttachmentImage,
  getUserId,
} from "../../../utils";
import { NOTIFICATION_LIST_DATE_TIME } from "../../../constants";
import {
  CREATEDBY_FIRSTNAME,
  CREATEDBY_LASTNAME,
  MSG_DESCRIPTION,
  MSG_DOCUMENT,
  MSG_GRANDPARENT_ID,
  MSG_OBJECT_ID,
  MSG_PARENT_ID,
  TARGET_MSG_THREAD,
} from "../../../constants/literalConstant";
import { OVERVIEW, TARGET } from "../../../constants/routeConstants";
import { buildStrengthData } from "../../../utils/communication";
import { getBrowserTime } from "../../../utils/general";
import LoadingWidget from "Components/widgets/LoadingWidget";

const CommunicationNotificationListItem = ({
  handleClose,
  getUserData,
  notification,
  isReadNotification,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const containerRef = useRef();
  const [anchorEl, setAnchorEl] = useState(null);
  const userId = getUserId();
  // const [selectedFile, setSelectedFile] = useState({});
  const [MyMutation] = useMutation(updateNotificationMutation);
  const [toggleReplyTextField, setToggleReplyTextField] = useState(false);
  const [isLiked, setIsLiked] = useState(false);
  const [isLoved, setIsLoved] = useState(false);
  const [replyText, setReplyText] = useState("");
  const currentUserId = userId;
  const [isReadClass, setIsReadClass] = useState("primary");
  const [taggedKeywordsMainMessage, setTaggedKeywordsMainMessage] = useState(
    []
  );
  const submitResponseReplySectionButton = useRef();
  const [isSendingText, setIsSendingText] = useState(false);
  const { strengths } = useRecoilValue(metaDataDetails);
  const [strengthListData, setStrengthListData] = useState([]);
  const history = useHistory();

  const notificationDate = getBrowserTime(
    get(notification, "createdAt", ""),
    NOTIFICATION_LIST_DATE_TIME
  );

  useEffect(() => {
    get(notification, "Isread", false)
      ? setIsReadClass("grey")
      : setIsReadClass("primary");
    const relevantStrengthData = flatten(buildStrengthData(strengths));
    setStrengthListData(relevantStrengthData);
  }, []);

  const [saveLikesForParentMessageData] = useMutation(
    saveLikesForParentMessage
  );

  const [saveLikesForGrandParentMessageData] = useMutation(
    saveLikesForGrandParentMessage
  );

  const [replyToGrandParentMessageData] = useMutation(
    replyToGrandParentMessage
  );

  const [replyToParentMessageData] = useMutation(replyToParentMessage);

  const [addMessageAttachmentData] = useMutation(addMessageAttachment);

  const [addGifAttachmentData] = useMutation(addGifAttachment);

  // popover
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const changeNotification = (variables, updateType) => {
    MyMutation({ variables })
      .then(() => {
        if (getUserData) {
          if (updateType === "isRead") {
            // TODO: remove if not needed
            isReadNotification();
          } else if (updateType === "delete") {
            getUserData();
          }
        }
      })
      .catch((error) => console.log(error));
  };

  const updateNotification = (notificationItem, redirect = false) => {
    if (!get(notificationItem, "Isread", false)) {
      const variables = {
        input: {
          userId,
          id: notificationItem.id,
          Isread: true,
        },
      };
      changeNotification(variables, "isRead");
      // openRespectiveCommunicationPage(notificationItem);
    }
    redirect && handleClose();
  };

  const deleteNotification = (notificationItem) => {
    const variables = {
      input: {
        userId,
        id: notificationItem.id,
        isDeleted: true,
        Isread: true,
      },
    };
    changeNotification(variables, "delete");
  };

  // const openRespectiveCommunicationPage = notificationItem => { };

  // const atlText = () => {
  //   return upperCase(
  //     `${get(notification, "user.firstName", "")[0]}${
  //     get(notification, "user.lastName", "")[0]
  //     }`
  //   );
  // };

  const saveLikesForResponseMessage = (
    createdByUserId,
    id,
    type = "Like",
    liked = true
  ) => {
    const saveLikesForResponseMessageVariables = {
      input: {
        createdByUserId,
        responseType: type,
        id,
        loveLikeResponse: {
          isLiked: liked,
          userId: currentUserId,
        },
      },
    };
    saveLikesForParentMessageData({
      variables: saveLikesForResponseMessageVariables,
    })
      .then(() => {
        updateNotification(notification);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const saveLikesforMainMessage = (
    messageId,
    userid,
    type = "Like",
    liked = true
  ) => {
    const saveLikesforMainMessageVariables = {
      input: {
        id: messageId,
        responseType: type,
        loveLikeResponse: {
          isLiked: liked,
          userId: userid,
        },
      },
    };
    saveLikesForGrandParentMessageData({
      variables: saveLikesforMainMessageVariables,
    })
      .then(() => {
        updateNotification(notification);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const replyToResponseMessage = (
    mainMessageId,
    messageText,
    parentMessageId,
    addedTags,
    createdByUserId
  ) => {
    const replyToMainMessageVariables = {
      input: {
        createdByUserId,
        message: messageText,
        grandParentMessageId: mainMessageId,
        responseType: "Text",
        parentMessageId,
        taggedKeywords: addedTags,
      },
    };

    replyToParentMessageData({ variables: replyToMainMessageVariables })
      .then(() => {
        setReplyText("");
        setIsSendingText(false);
        updateNotification(notification);
        setToggleReplyTextField(!toggleReplyTextField);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const replyToMainMessage = (
    mainMessageId,
    replyMessageText,
    addedTags,
    createdByUserId
  ) => {
    const replyToMainMessageVariables = {
      input: {
        createdByUserId,
        message: replyMessageText,
        grandParentMessageId: mainMessageId,
        responseType: "Text",
        taggedKeywords: addedTags,
      },
    };

    replyToGrandParentMessageData({ variables: replyToMainMessageVariables })
      .then(() => {
        setReplyText("");
        setIsSendingText(false);
        updateNotification(notification);
        setToggleReplyTextField(!toggleReplyTextField);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const addGifMessage = (gifUrl, mainMessageId, createdByUserId) => {
    const addGifAttachmentDataVariables = {
      input: {
        gifUrl,
        responseType: "GIF",
        createdByUserId,
        grandParentMessageId: mainMessageId,
      },
    };
    if (addGifAttachmentDataVariables.input) {
      addGifAttachmentData({ variables: addGifAttachmentDataVariables })
        .then(() => {
          updateNotification(notification);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      // no gif added
    }
  };

  const uploadFileByUrl = (uploadUrl, file) => {
    axios
      .put(uploadUrl, file, {
        headers: {
          "Content-Type":
            "image/jpeg, image/png, application/pdf, application/vnd.ms-excel, application/msword",
        },
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log("Error", error);
      });
  };

  const addAttachmentGrandParentMessage = (
    mainMessageId,
    files,
    createdByUserId,
    editMessageId = null,
    isEdit = false
  ) => {
    const setSelectedFileDetails = {
      fileName: files[0].name,
      key: files[0].name,
    };
    const replyToMainMessageVariables = {
      input: {
        createdByUserId,
        grandParentMessageId: mainMessageId,
        responseType: "Document",
        document: setSelectedFileDetails,
      },
    };
    if (isEdit) {
      replyToMainMessageVariables.input["id"] = editMessageId;
    }
    if (replyToMainMessageVariables.input) {
      addMessageAttachmentData({ variables: replyToMainMessageVariables })
        .then((res) => {
          if (get(res, TARGET_MSG_THREAD, null)) {
            uploadFileByUrl(
              get(
                res,
                "data.targetMessageThreadMutation.document.uploadUrl",
                ""
              ),
              files[0]
            );
            updateNotification(notification);
          } else {
            //love like failed
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      //
    }
  };

  const RenderThumbnailElement = (ThumbnailIcon, url) => (
    <a target="_blank" href={url} rel="noreferrer">
      <img src={ThumbnailIcon} alt="thumbnail" className="mr10" />
    </a>
  );

  const renderThumbnail = (fileName, url) => {
    const splitFileName = (fileName || "").split(".");
    const fileExtension = splitFileName.length
      ? splitFileName[splitFileName.length - 1]
      : "";
    if (fileName) {
      const attachment = defaultAttachmentImage(fileName);
      if (get(attachment, "attachmentType", "") === "video") {
        return RenderThumbnailElement(VideoThumbnail, url);
      }
    }
    switch (fileExtension) {
      case "doc":
        return RenderThumbnailElement(DocThumbnail, url);
      case "pdf":
        return RenderThumbnailElement(PdfThumbnail, url);
      case "xlsx":
        return RenderThumbnailElement(XlsThumbnail, url);
      case "jpg":
      case "svg":
      case "png":
        return (
          <a target="_blank" rel="noreferrer" href={url}>
            <img src={url} className={classes.imageWidht} alt="thumbnail" />
          </a>
        );
      default:
        return (
          <a
            target="_blank"
            rel="noreferrer"
            href={get(notification, MSG_DOCUMENT, "")}
          >
            {t("dashboard.notificationsFileShare")}
          </a>
        );
    }
  };

  const sendTextReply = () => {
    setIsSendingText(true);
    if (get(notification, MSG_PARENT_ID) !== null) {
      replyToResponseMessage(
        get(notification, MSG_GRANDPARENT_ID, ""),
        replyText,
        get(notification, MSG_PARENT_ID),
        taggedKeywordsMainMessage,
        currentUserId
      );
    } else {
      replyToMainMessage(
        get(notification, MSG_GRANDPARENT_ID, ""),
        replyText,
        taggedKeywordsMainMessage,
        currentUserId
      );
    }
  };
  const displayTextMessage = () => {
    return (
      <Tooltip title={get(notification, MSG_DESCRIPTION, "")}>
        <Typography
          variant="body2"
          className="f-gray font-13 multi-wrap-1 pre-wrap"
        >
          {get(notification, MSG_DESCRIPTION, "") &&
          get(notification, MSG_DESCRIPTION, "").length > 100
            ? `${get(notification, MSG_DESCRIPTION, "").substring(0, 100)}...`
            : get(notification, MSG_DESCRIPTION, "")}
        </Typography>
      </Tooltip>
    );
  };
  const displayCommunicationData = () => {
    if (checkStringLength(get(notification, MSG_DOCUMENT, ""))) {
      return (
        <Fragment>
          {displayTextMessage()}
          <Typography
            variant="body2"
            className="font-13 truncate-txt"
            noWrap="true"
          >
            {renderThumbnail(
              get(notification, "message.documentName", ""),
              get(notification, MSG_DOCUMENT, "")
            )}
          </Typography>
        </Fragment>
      );
    } else if (checkStringLength(get(notification, "message.gifUrl", ""))) {
      return (
        <Typography variant="body2" className="font-13" noWrap="true">
          <img
            className={classes.imageWidht}
            src={get(notification, "message.gifUrl", "")}
            alt="GIF"
            
          />
        </Typography>
      );
    } else if (checkStringLength(get(notification, MSG_DESCRIPTION, ""))) {
      return displayTextMessage();
    } else {
      return null;
    }
  };
  return (
    <Box className={classes.notifList}>
      <ListItem
        className={
          get(notification, "Isread", false) ? classes.readMessage : ""
        }
      >
        <ListItemText>
          <Box
            display="flex"
            data-testid="updateNotification"
            onClick={() => {
              updateNotification(notification, true);
              history.push({
                pathname: `${TARGET}${OVERVIEW}/${notification?.targetId}`,
                state: {
                  openMessagePanel: true,
                  message: notification?.message,
                },
              });
            }}
          >
            <UserProfileWidget
              firstName={get(notification, CREATEDBY_FIRSTNAME, "")}
              lastName={get(notification, CREATEDBY_LASTNAME, "")}
              url={get(notification, "createdBy.profileImage.fileName", "")}
            />
            <Box width="80%">
              <Box display="flex" alignItems="center">
                <Tooltip
                  title={`${get(notification, CREATEDBY_FIRSTNAME, "")}
                    ${get(notification, CREATEDBY_LASTNAME, "")}`}
                >
                  <Typography
                    variant="subtitle2"
                    className="font-13"
                    noWrap="true"
                  >
                    {get(notification, CREATEDBY_FIRSTNAME, "")}{" "}
                    {get(notification, CREATEDBY_LASTNAME, "")}
                  </Typography>
                </Tooltip>
                <span className={classes.vertDivider}>|</span>
                <Tooltip title={get(notification, "message.target.title", "")}>
                  <Typography variant="body2" className="font-13" noWrap="true">
                    {get(notification, "message.target.title", "")}
                  </Typography>
                </Tooltip>
              </Box>
              {displayCommunicationData()}
              <Typography variant="body2" className="f-light-gray font-12">
                {notificationDate}
              </Typography>
            </Box>
          </Box>
          <Box ref={containerRef} className={classes.notifAction} mt={1}>
            <Box>
              <IconButton
                aria-label="like"
                // color={isReadClass}
                size="small"
                className={isLiked ? classes.selectedLikeIcon : ""}
                onClick={() => {
                  setIsLiked(!isLiked);
                  setIsLoved(isLiked);
                  if (get(notification, MSG_PARENT_ID) !== null) {
                    saveLikesForResponseMessage(
                      get(notification, "userId", ""),
                      get(notification, MSG_OBJECT_ID, ""),
                      "Like",
                      !isLiked
                    );
                  } else {
                    saveLikesforMainMessage(
                      get(notification, MSG_OBJECT_ID, ""),
                      currentUserId,
                      "Like",
                      !isLiked
                    );
                  }
                }}
              >
                {isLiked ? (
                  <ThumbUp fontSize="small" />
                ) : (
                  <ThumbUpAltOutlined fontSize="small" />
                )}
              </IconButton>
              <IconButton
                aria-label="love"
                // color={isReadClass}
                size="small"
                className={isLoved ? classes.selectedFavIcon : ""}
                data-testid="love"
                onClick={() => {
                  setIsLoved(!isLoved);
                  setIsLiked(isLoved);
                  if (get(notification, MSG_PARENT_ID) !== null) {
                    saveLikesForResponseMessage(
                      get(notification, "userId", ""),
                      get(notification, MSG_OBJECT_ID, ""),
                      "Love",
                      !isLoved
                    );
                  } else {
                    saveLikesforMainMessage(
                      get(notification, MSG_OBJECT_ID, ""),
                      currentUserId,
                      "Love",
                      !isLoved
                    );
                  }
                }}
              >
                {isLoved ? (
                  <Favorite fontSize="small" />
                ) : (
                  <FavoriteBorderOutlined fontSize="small" />
                )}
              </IconButton>
              {!(get(notification, MSG_PARENT_ID, "") || "").length ? (
                <Fragment>
                  <Popover
                    container={containerRef.current}
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    data-testid="handlepop"
                    onClose={handlePopoverClose}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "center",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "center",
                    }}
                    className={classes.gifPopover}
                  >
                    <GifSearchBox
                      onSelect={(item) => {
                        const gifUrl = get(item, "images.downsized.url", "");
                        addGifMessage(
                          gifUrl,
                          get(notification, MSG_GRANDPARENT_ID, ""),
                          get(notification, "userId", "")
                        );
                        setAnchorEl(null);
                      }}
                      masonryConfig={[
                        { columns: 2, imageWidth: 110, gutter: 5 },
                        { mq: "700px", columns: 3, imageWidth: 120, gutter: 5 },
                      ]}
                    />
                  </Popover>
                  <IconButton
                    size="small"
                    aria-label="gif"
                    color={isReadClass}
                    data-testid="handleClick"
                    onClick={handleClick}
                    aria-describedby={id}
                  >
                    <img src={GifIcon} />
                  </IconButton>
                  <IconButton
                    aria-label="upload"
                    color={isReadClass}
                    className={classes.uploadBtn}
                  >
                    <UploadButton
                      color={isReadClass}
                      icon={PublishOutlined}
                      onChange={(e) => {
                        if (e.target.files && !isEmpty(e.target.files)) {
                          addAttachmentGrandParentMessage(
                            get(notification, MSG_GRANDPARENT_ID, ""),
                            e.target.files,
                            currentUserId,
                            null,
                            false
                          );
                        }
                      }}
                      type="file"
                      inputProps={{
                        accept:
                          "image/jpeg, image/png, application/pdf, application/vnd.ms-excel, application/msword",
                      }}
                      id={`icon-button-file-${get(notification, "id", "")}`}
                      onClick={(event) => {
                        // setSelectedFile({});
                        event.target.value = null;
                      }}
                    />
                  </IconButton>
                </Fragment>
              ) : null}
            </Box>
            {/* className={ false ? `${classes.selected} ${classes.replyButton}` : classes.replyButton } */}
            <Button
              aria-label="reply"
              data-testid="setToggleReplyTextField"
              // color={isReadClass}
              color="primary"
              size="small"
              onClick={() => setToggleReplyTextField(!toggleReplyTextField)}
            >
              <img src={ReplyIcon} />
              <Typography variant="body2" className="font-13 ml5">
                {"Reply"}
              </Typography>
            </Button>
          </Box>
          {toggleReplyTextField && (
            <Box
              className={`${classes.replyTextfield} ${classes.emojiPicker}`}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              width="100%"
              mt={1}
            >
              <EmojiPicker setComment={setReplyText} comment={replyText} />
              <TextAreaMention
                disabled={isSendingText}
                placeholder="Reply"
                replyResponseMessageText={replyText}
                onEnterSubmit={(event, enterPress) => {
                  if (!event?.shiftKey) {
                    onEnterSubmit(
                      event,
                      submitResponseReplySectionButton,
                      enterPress
                    );
                  }
                }}
                data-testid="onChange"
                onChange={(event, newValue, newPlainTextValue, mentions) => {
                  const { value } = get(event, "target");
                  setReplyText(value);
                  addStrengthToText(
                    event,
                    newValue,
                    newPlainTextValue,
                    mentions,
                    setReplyText,
                    setTaggedKeywordsMainMessage,
                    taggedKeywordsMainMessage,
                    true
                  );
                }}
                strengthListData={strengthListData}
              />
              <IconButton
                data-testid="sendTextReply"
                disabled={isSendingText}
                aria-label="send"
                size="small"
                onClick={() => sendTextReply()}
                ref={submitResponseReplySectionButton}
              >
                {isSendingText ? (
                  <LoadingWidget color="grey" />
                ) : (
                  <img src={SendIcon} />
                )}
              </IconButton>
            </Box>
          )}
        </ListItemText>
        <Tooltip title="Remove">
          <IconButton
            data-testid="deleteNotification"
            aria-label="remove"
            onClick={() => deleteNotification(notification)}
            size="small"
            className={classes.closeIcon}
          >
            <CloseOutlinedIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </ListItem>
    </Box>
  );
};

export default CommunicationNotificationListItem;
